import React, { useMemo } from 'react';
import { Grid2 } from "@mui/material";
import CardAdministrador from "../../../components/ui/materialui/cardAdministrador";
import { 
  DocumentScanner, 
  Podcasts, 
  WorkspacePremium, 
  UpdateRounded, 
  InsertDriveFile, 
  Today, 
  MoveToInbox as MoveToInboxIcon,
  AssuredWorkload as AssuredWorkloadIcon 
} from "@mui/icons-material";
import { usePermissions } from '../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../utils/enums';

interface SecureLink {
  to: string;
  icon: JSX.Element;
  text: string;
  permissions: TipoFuncionalidad[];
}

const Reportes: React.FC = () => {
  const { hasPermission } = usePermissions();

  const filterLinks = (links: SecureLink[]) => 
    links.filter(link => link.permissions.some(perm => hasPermission(perm)));


  const linksConsultas = useMemo(() => filterLinks([
    {
      to: "/reportes/dividendos-mes",
      icon: <Podcasts sx={{ fontSize: 22, color: "#17c2e6" }} />,
      text: "Dividendos mes",
      permissions: [TipoFuncionalidad.Reporte_consultas]
    },
    {
      to: "/reportes/recaudacion-diaria",
      icon: <Today sx={{ fontSize: 22, color: "#17c2e6" }} />,
      text: "Recaudación diaria",
      permissions: [TipoFuncionalidad.Reporte_consultas]
    },
  ]), [hasPermission]);

  const linksCertificadosPortabilidad = useMemo(() => filterLinks([
    {
      to: "/certificadosPortabilidad/liquidacionDeuda",
      icon: <MoveToInboxIcon sx={{ fontSize: 22, color: "#ACD35E" }} />,
      text: "Liquidación de deuda",
      permissions: [TipoFuncionalidad.Reportes_portabilidad]
    },
    {
      to: "/certificadosPortabilidad/actualizacionDeuda",
      icon: <UpdateRounded sx={{ fontSize: 22, color: "#ACD35E" }} />,
      text: "Actualización de deuda",
      permissions: [TipoFuncionalidad.Reportes_portabilidad]
    },
  ]), [hasPermission]);

  const linksCMF = useMemo(() => filterLinks([
    {
      to: "/reportes/informes-cmf",
      icon: <MoveToInboxIcon sx={{ fontSize: 22, color: "#17c2e6" }} />,
      text: "Generación de informes",
      permissions: [TipoFuncionalidad.Reportes_CMF]
    },
  ]), [hasPermission]);

  const linksSii = useMemo(() => filterLinks([
    {
      to: "/reportes/declaracion-jurada-sii",
      icon: <InsertDriveFile sx={{ fontSize: 22, color: "#ACD35E" }} />,
      text: "Declaraciones juradas",
      permissions: [TipoFuncionalidad.Reportes_SII]
    },
    {
      to: "/reportes/certificados-sii",
      icon: <MoveToInboxIcon sx={{ fontSize: 22, color: "#ACD35E" }} />,
      text: "Certificados",
      permissions: [TipoFuncionalidad.Reportes_SII]
    },
  ]), [hasPermission]);

  return (
    <div>
      <Grid2 container spacing={2} sx={{ mt: 2 }}>
        {linksConsultas.length > 0 && (
          <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
            <CardAdministrador
              title="Consultas"
              icon={<DocumentScanner sx={{ fontSize: 20, color: "white" }} />}
              links={linksConsultas}
              backgroundColor="#17c2e6"
              linkTextColor="text-info"
            />
          </Grid2>
        )}

        {linksCertificadosPortabilidad.length > 0 && (
          <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
            <CardAdministrador
              title="Certificados portabilidad"
              icon={<DocumentScanner sx={{ fontSize: 20, color: "white" }} />}
              links={linksCertificadosPortabilidad}
              backgroundColor="#ACD35E"
              linkTextColor="text-info"
            />
          </Grid2>
        )}

        {linksCMF.length > 0 && (
          <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
            <CardAdministrador
              title="Informes CMF"
              icon={<AssuredWorkloadIcon sx={{ fontSize: 20, color: "white" }} />}
              links={linksCMF}
              backgroundColor="#17c2e6"
              linkTextColor="text-info"
            />
          </Grid2>
        )}

        {linksSii.length > 0 && (
          <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
            <CardAdministrador
              title="SII"
              icon={<WorkspacePremium sx={{ fontSize: 20, color: "white" }} />}
              links={linksSii}
              backgroundColor="#ACD35E"
              linkTextColor="text-info"
            />
          </Grid2>
        )}
      </Grid2>
    </div>
  );
};

export default Reportes;